import { DEFAULT_DATE_FORMAT } from "@/static/dateFormats";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, IsArray, ValidateNested } from "class-validator";
import dayjs from "dayjs";

export class AddEditContractorDocumentTemplate {
  @Expose()
  @IsBoolean()
  isMonthly!: boolean;

  @Expose()
  @IsBoolean()
  isYearly!: boolean;

  @Expose()
  @IsString()
  counterTemplate!: string;

  @Expose()
  @IsString()
  startDate!: string;

  @Expose()
  @IsOptional()
  @IsString()
  endDate!: string | null;

  constructor() {
    this.isMonthly = true;
    this.isYearly = false;
    this.counterTemplate = "";
    this.startDate = dayjs().add(1, "day").format(DEFAULT_DATE_FORMAT);
    this.endDate = null;
  }
}

export class ContractorDocumentTemplate {
  @Expose()
  @IsNumber()
  documentTypeId!: number;

  @Expose()
  @IsString()
  documentTypeName!: string;

  @Expose()
  @IsString()
  counterTemplate!: string;

  @Expose()
  @IsString()
  @IsOptional()
  documentLayout!: string;

  @Expose()
  @IsBoolean()
  isMonthly!: boolean;

  @Expose()
  @IsBoolean()
  isYearly!: boolean;

  @Expose()
  @IsBoolean()
  isActive!: boolean;

  @Expose()
  @IsBoolean()
  isEditable!: boolean;

  @Expose()
  @IsBoolean()
  isEndDateEditable!: boolean;

  @Expose()
  @IsArray()
  @Type(() => ContractorTemplate)
  @ValidateNested()
  contractorTemplates!: Array<ContractorTemplate>;
}

export class ContractorTemplate {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  counterTemplate!: string;

  @Expose()
  @IsBoolean()
  isMonthly!: boolean;

  @Expose()
  @IsBoolean()
  isYearly!: boolean;

  @Expose()
  @IsString()
  startDate!: string;

  @Expose()
  @IsOptional()
  @IsString()
  endDate!: string | null;

  @Expose()
  @IsBoolean()
  isActive!: boolean;
}
